// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Stock_ReturnItemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/stock/return_item
 *
 * Returns the inserted stock-movement id for the return movement
 * (`{movement_id: int}`).
 *
 * @see So_stock_movements_model::createMovement()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Stock_ReturnItemResponseDados {
movement_id: number
}

export type Stock_ReturnItemResponse = ApiResponse<Stock_ReturnItemResponseDados>;

registerResponseContract('Stock_ReturnItemResponse', {
  movement_id: { type: 'number',  required: true },
})
